module.exports = __webpack_public_path__ + "img/BMRK.2638786a.png";